<template>
  <div class="product_detail">
    <div class="detail_header">
      <img
        src="https://oss.txfenqi.com/txfqpro_app/images/index/icon_back.png"
        alt=""
        @click="goBack"
      />

      <div>{{ detailData.productName }}</div>
    </div>
    <div class="detail_container">
      <div class="data_box">
        <div class="d_b_desc">可借范围(元)</div>
        <div @click="handleFocus" class="d_b_amount_box">
          <div class="d_b_amount">
            <div class="d_b_momey">{{ detailData.minAmount }}-{{ detailData.maxAmount }}</div>
            <!--            <input
              @blur="handleBlur"
              :focus="isFocused"
              ref="editAmount"
              v-model="detailData.creditAmount"
              class="custom-input"
              type="tel"
            />-->
            <img
              src="https://oss.txfenqi.com/txfqpro_app/images/institution/institution_amount_bg.png"
              mode=""
            />
          </div>
          <!-- <img
            class="edit_img"
            src="https://oss.txfenqi.com/txfqpro_app/images/institution/icon_edit.png"
            mode=""
          /> -->
        </div>
        <div class="data_bottom_box">
          <div class="d_b_item_box">
            <div class="num_span">
              <!-- 产品详情与贷超列表保持同一利率上限，缺失时显示 24%。 -->
              {{ detailData.minLoanRate || detailData.timeLimitLoanRate || 0 }}%-{{
                detailData.maxLoanRate || 24
              }}%
            </div>
            <!-- 单利与息费口径属于利率说明，紧跟利率值而非审核条件。 -->
            <div class="num_span_desc num_span_desc--rate">年利率(单利，已含全部息费)</div>
          </div>
          <div class="d_b_item_box">
            <div class="num_span">{{ detailData.loanMinPeriod }}-{{ detailData.loanPeriod }}</div>
            <div class="num_span_desc">期限(月)</div>
          </div>
          <!-- <div class="d_b_item_box">
					<div class="num_span">18001.12</div>
					<div class="num_span_desc">应还总额(元)</div>
				</div> -->

          <div class="line_first"></div>
          <!-- <div class="line_second"></div> -->
        </div>
      </div>

      <div class="check_declaration_card" v-if="detailData.auditInfo">
        <span class="title">审核说明</span>
        <div v-for="(value, key) in detailData.auditInfo" :key="key" class="declartion_item">
          <span class="d_i_l">{{ key }}</span>
          <span class="d_i_r">{{ value }}</span>
        </div>
      </div>

      <div class="check_declaration_card">
        <span class="title">机构详情</span>
        <div class="declartion_item">
          <span class="d_i_l">服务机构</span>
          <span class="d_i_r">{{ detailData.organizationName }}</span>
        </div>
        <!-- 机构联系方式以详情接口为准，缺失字段不占用页面行。 -->
        <div v-if="detailData.organizationPhone" class="declartion_item">
          <span class="d_i_l">机构电话</span>
          <span class="d_i_r">{{ detailData.organizationPhone }}</span>
        </div>
        <div v-if="detailData.officialWebsite" class="declartion_item declartion_item--website">
          <span class="d_i_l">官方网站</span>
          <span class="d_i_r">{{ detailData.officialWebsite }}</span>
        </div>
      </div>

      <div class="desc_span_box">
        <div class="desc_span">本次服务由第三方合作机构{{ detailData.productName }}为您提供</div>
        <div class="desc_span">本平台仅提供借款信息展示，不参与后续任何放款行为</div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bottom_box">
      <div class="b_b_desc">
        <!-- 协议勾选状态由本地样式绘制，避免外部图标失效时无法识别当前状态。 -->
        <button
          type="button"
          class="agreement-check"
          :class="{ 'agreement-check--active': isRead }"
          :aria-pressed="isRead"
          :aria-label="isRead ? '取消同意协议' : '同意协议'"
          @click="toggleAgreementRead"
        ></button>
        <span class="span_box">
          <span class="black_span">我已阅读并同意</span>
          <span
            v-for="(contract, index) in detailData.productContractDTOS"
            :key="'contract' + index"
            @click="onContractClick(contract)"
            class="orange_span"
            >《{{ contract.contractName }}》</span
          >
          <!--          <span
            v-if="checkMobileStatus == 2"
            @click="handleProtocol('content', 105)"
            >《联合登录授权协议》</span
          >-->
          <!--          <span
            v-if="checkMobileStatus == 3"
            @click="handleProtocol('content', 13)"
            >《个人信息共享授权书》</span
          >
          <span
            v-if="checkMobileStatus == 3"
            @click="handleProtocol('content', 14)"
            >《知情告知书》</span
          >-->
        </span>
      </div>
      <div @click="handleApply" class="b_b_btn">立即申请</div>
    </div>
    <van-popup
      v-model="isShowProtocol"
      round
      position="bottom"
      :safe-area-inset-bottom="true"
      :close-on-click-overlay="false"
      :style="{ height: '11rem' }"
    >
      <van-icon class="close-btn" name="close" size="0.5rem" @click="onClickCloseIcon" />
      <div class="popup-content">
        <div class="popup-content-title">
          {{ currentAgreeName }}
        </div>
        <ProtocolPopup
          :protocolType="protocolType"
          :protocolUrl="currentAgreeUrl"
          :protocolContent="currentProtocolContent"
        />
      </div>
    </van-popup>
    <van-popup
      v-model="showPreRead"
      position="bottom"
      round
      :close-on-click-overlay="false"
      class="pre-read-popup"
    >
      <div class="pre-read-header">
        <span v-if="preReadRemaining > 0" class="pre-read-countdown">{{ preReadRemaining }}</span>
        <strong>协议授权</strong>
        <button type="button" class="pre-read-close" aria-label="暂不同意" @click="closePreRead">
          ×
        </button>
      </div>
      <div class="pre-read-body">
        <p class="pre-read-intro">协议条款包括以下内容：</p>
        <section v-for="(contract, index) in preReadContracts" :key="contract.id || index">
          <h3>《{{ contract.contractName || '协议' }}》</h3>
          <div
            v-if="contract.contractContent"
            class="pre-read-html"
            v-html="contract.contractContent"
          ></div>
          <iframe
            v-else-if="contract.contractUrl"
            class="pre-read-frame"
            :src="contract.contractUrl"
            :title="contract.contractName || '协议'"
          ></iframe>
        </section>
      </div>
      <div class="pre-read-actions">
        <button
          type="button"
          class="pre-read-agree"
          :disabled="preReadRemaining > 0"
          @click="completePreRead"
        >
          我已阅读并同意全部协议{{ preReadRemaining > 0 ? `（${preReadRemaining}）` : '' }}
        </button>
        <button type="button" class="pre-read-decline" @click="closePreRead">暂不同意</button>
      </div>
    </van-popup>
    <div class="stance"></div>
  </div>
</template>

<script>
import ProtocolPopup from '@/components/protocolPopup/index.vue'
import * as API_Common from '@/api/common.js'
import { setCookie } from '@/utils/cookies.js'
import { formatAppFrameLinkUrl } from '@/utils/appFrameUrl.js'
import { throttle } from '@/utils/function.js'

export default {
  name: 'ProductDetail',
  components: {
    ProtocolPopup,
  },
  data() {
    return {
      popupShow: false,
      productTitle: '',
      isShowProtocol: false,
      editAmount: null,
      isRead: false,
      productId: null,
      detailData: {},
      isFocused: false,
      currentAgreeUrl: '',
      currentAgreeName: '',
      currentProtocolContent: '',
      protocolType: '', //协议类型是contnt还是url
      showPage: 17, // 贷超17，结果页15
      checkMobileStatus: null, //2是联登，展示联登协议，3是半流程，展示《个人信息共享授权书》、《知情告知书》
      unifiedLoginProtocol: {}, //联登协议
      personalInformationSharingAuthorization: {}, //个人信息共享授权书
      informedConsent: {}, //知情告知书
      showPreRead: false,
      preReadContracts: [],
      preReadRemaining: 0,
      preReadTimer: null,
      pendingLinkUrl: '',
    }
  },

  created() {
    window.__TRACK_SCENE_KEY__ = 'productDetail'
  },

  mounted() {
    if (this.$route.query.productId) {
      this.productId = this.$route.query.productId
    }
    if (this.$route.query.showPage) {
      this.showPage = Number(this.$route.query.showPage)
    }
    this.trackDaichaoDetailPv()
    this.getProductDetail()
  },
  beforeDestroy() {
    this.clearPreReadTimer()
  },
  methods: {
    clearPreReadTimer() {
      if (this.preReadTimer) {
        clearInterval(this.preReadTimer)
        this.preReadTimer = null
      }
    },
    closePreRead() {
      this.clearPreReadTimer()
      this.showPreRead = false
      this.preReadContracts = []
      this.preReadRemaining = 0
      this.pendingLinkUrl = ''
    },
    completePreRead() {
      // 强制阅读结束且用户主动确认后才记录点击并跳转，倒计时本身不代表同意。
      if (this.preReadRemaining > 0 || !this.pendingLinkUrl) return
      const linkUrl = this.pendingLinkUrl
      this.closePreRead()
      this.recordLoanAndJump(linkUrl)
    },
    openPreRead(checkData) {
      const contracts = Array.isArray(checkData.productContractDTOS)
        ? checkData.productContractDTOS
        : []
      // 缺少任何一份协议内容时拒绝继续，避免用户在未看到条款的情况下授权。
      if (
        !contracts.length ||
        contracts.some(
          (contract) => !contract || (!contract.contractContent && !contract.contractUrl)
        )
      ) {
        this.$toast.fail('协议内容暂不可用，请稍后重试')
        return
      }

      // 优先累计接口指定的强读时间；未给出有效秒数时默认阅读 3 秒。
      const seconds = contracts.reduce(
        (total, contract) =>
          total +
          (Number(contract.forceRead) === 1 ? Math.max(0, Number(contract.readSecond) || 0) : 0),
        0
      )
      this.clearPreReadTimer()
      this.preReadContracts = contracts
      this.pendingLinkUrl = checkData.linkUrl
      this.preReadRemaining = seconds > 0 ? Math.ceil(seconds) : 3
      this.showPreRead = true
      if (this.preReadRemaining > 0) {
        const deadline = Date.now() + this.preReadRemaining * 1000
        this.preReadTimer = setInterval(() => {
          this.preReadRemaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000))
          if (this.preReadRemaining === 0) this.clearPreReadTimer()
        }, 250)
      }
    },
    trackDaichaoDetailPv() {
      API_Common.handleBatchTrackBase('20129')
    },
    trackDaichaoDetailCheckAgreement() {
      API_Common.handleBatchTrackBase('20130')
    },
    trackDaichaoDetailProtocolClick(contract) {
      API_Common.handleBatchTrackBase('20131', {
        remark: contract && contract.contractName ? contract.contractName : '',
      })
    },
    trackDaichaoDetailApplyClick() {
      API_Common.handleBatchTrackBase('20132', {
        remark: this.productId != null ? String(this.productId) : '',
      })
    },

    goBack() {
      this.$router.go(-1)
    },
    onClickCloseIcon() {
      this.isShowProtocol = false
    },

    // 协议弹窗关闭
    handleCloseProtoPopup() {
      this.isShowProtocol = false
    },

    //查看协议
    handleProtocol(type, pageType, contract) {
      this.isShowProtocol = true
      if (type == 'url') {
        this.protocolType = 'url'
        this.currentAgreeUrl = contract.contractUrl
        this.currentAgreeName = contract.contractName
      } else if (type == 'content') {
        this.protocolType = 'content'
        // this.getProtocol(pageType);
        this.currentProtocolContent = contract.contractContent
        this.currentAgreeName = contract.contractName
      }
    },

    onContractClick(contract) {
      this.trackDaichaoDetailProtocolClick(contract)
      this.handleProtocol('content', '', contract)
    },

    toggleAgreementRead() {
      const nextVal = !this.isRead
      this.isRead = nextVal
      if (nextVal) {
        this.trackDaichaoDetailCheckAgreement()
      }
    },

    // 立即申请
    handleApply: throttle(async function () {
      this.trackDaichaoDetailApplyClick()
      if (!this.isRead) {
        this.$toast('请先阅读并同意协议')
        return
      }

      this.getProductCheckUrl()
    }),

    // 获取贷超详情数据
    async getProductDetail() {
      let that = this
      API_Common.getProductDetailRequest(this.productId).then((res) => {
        if (res.code == 200 && res.data) {
          console.log('getProductDetail', res)
          // if (res.data.checkMobileStatus == 2) {
          //   this.getProtocol(105, "unifiedLoginProtocol");
          // } else if (res.data.checkMobileStatus == 3) {
          //   this.getProtocol(13, "personalInformationSharingAuthorization");
          //   this.getProtocol(14, "informedConsent");
          // }
          that.checkMobileStatus = res.data.checkMobileStatus
          that.detailData = res.data
          /*that.detailData.auditInfo =
            res.data.auditInfo && res.data.auditInfo != ""
              ? JSON.parse(res.data.auditInfo)
              : undefined;*/

          // 解析并过滤，只保留年龄字段
          if (res.data.auditInfo && res.data.auditInfo != '') {
            try {
              const auditInfo = JSON.parse(res.data.auditInfo)
              // 只保留年龄字段
              that.detailData.auditInfo = auditInfo['年龄']
                ? { 年龄: auditInfo['年龄'] }
                : undefined
            } catch (e) {
              console.error('解析auditInfo失败:', e)
              that.detailData.auditInfo = undefined
            }
          } else {
            that.detailData.auditInfo = undefined
          }
        } else {
          that.$toast.fail(res.msg)
        }
      })
    },
    // 立即申请，请求跳转url
    async getProductCheckUrl() {
      // 此处只校验并获取协议；记录点击必须等用户完成前置阅读、准备跳转时再发送。
      API_Common.productCheckRequest({ productId: this.productId })
        .then((res) => {
          if (!res || Number(res.code) !== 200 || !res.data || !res.data.linkUrl) {
            throw new Error((res && res.msg) || '获取跳转链接失败')
          }
          this.productId = res.data.productId || this.productId
          // check 要求前置阅读时先展示授权弹窗，结束前不得记录点击或进入下游页面。
          if (Number(res.data.preRead) === 1) {
            this.openPreRead(res.data)
            return
          }
          this.recordLoanAndJump(res.data.linkUrl)
        })
        .catch((error) => {
          console.error('getProductCheckUrl error:', error)
          this.$toast.fail(
            (error.response && error.response.data && error.response.data.msg) ||
              error.message ||
              '获取产品信息失败'
          )
        })
    },
    // 获取联合登陆授权协议
    // getProtocol(pageType, protocolType) {
    //   let params = {
    //     pageType: pageType,
    //     showClient: 2,
    //   };
    //   let that = this;
    //   API_Common.getContent(params).then((res) => {
    //     if (res.code == 200) {
    //       that[protocolType] = res.data;
    //     }
    //   });
    // },
    getProtocol(pageType) {
      let params = {
        pageType: pageType,
        showClient: 2,
      }
      let that = this
      API_Common.getContent(params).then((res) => {
        if (res.code == 200) {
          that.currentProtocolContent = res.data.content
          that.currentAgreeName = res.data.name
        }
      })
    },
    jumpAppFrameAfterLoanRecord(linkUrl) {
      window.location.href =
        '/appFrame?productId=' + this.productId + '&url=' + formatAppFrameLinkUrl(linkUrl)
      sessionStorage.setItem('lastUrl', window.location.href)
    },
    recordLoanAndJump(linkUrl) {
      API_Common.addLoanRecordRequest({ productId: this.productId, showPage: this.showPage })
        .catch((error) => {
          // 埋点失败不应拦截已经完成协议授权的用户进入下游页面。
          console.error('addLoanRecord 失败', error)
        })
        .then(() => {
          setCookie('linkUrl', linkUrl)
          this.jumpAppFrameAfterLoanRecord(linkUrl)
        })
    },
    handleFocus() {
      this.isFocused = true
    },

    handleBlur() {
      this.isFocused = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep input {
  background-color: transparent !important;
}
.close-btn {
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
  color: #868e9e;
  font-size: 0.4rem;
}
.popup-content {
  padding: 0.7rem 0.32rem;
  font-size: 0.24rem !important;
  .popup-content-title {
    width: 100%;
    text-align: center;
    margin-bottom: 0.2rem;
  }
}
.pre-read-popup {
  // 协议从屏幕底部展开，长内容仅在正文区滚动，操作按钮始终留在底部。
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 82vh;
  overflow: hidden;
  background: #f7f8fa;
}
.pre-read-header {
  position: relative;
  flex-shrink: 0;
  padding: 0.3rem 0.72rem;
  background: #fff;
  color: #30343b;
  font-size: 0.32rem;
  text-align: center;
}
.pre-read-countdown {
  position: absolute;
  left: 0.28rem;
  top: 0.28rem;
  color: #ff831f;
  font-size: 0.25rem;
}
.pre-read-close {
  position: absolute;
  right: 0.22rem;
  top: 0.16rem;
  padding: 0 0.08rem;
  background: transparent;
  color: #333;
  font-size: 0.48rem;
}
.pre-read-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0.28rem;
  color: #333;
  font-size: 0.24rem;
  line-height: 1.6;
}
.pre-read-intro {
  margin-bottom: 0.2rem;
}
.pre-read-body h3 {
  margin: 0.22rem 0 0.14rem;
  font-size: 0.26rem;
}
.pre-read-html {
  overflow-wrap: anywhere;
}
// 接口协议中的有序列表需覆盖 H5 全局的 li 编号重置，与小程序保持一致。
.pre-read-html ::v-deep ol,
.pre-read-html ::v-deep ul {
  padding-left: 1.5em;
}
.pre-read-html ::v-deep ol {
  list-style-type: decimal;
}
.pre-read-html ::v-deep ul {
  list-style-type: disc;
}
.pre-read-html ::v-deep li {
  list-style-type: inherit;
}
.pre-read-html ::v-deep img {
  max-width: 100%;
  height: auto;
}
.pre-read-frame {
  width: 100%;
  min-height: 7rem;
  border: 0;
}
.pre-read-actions {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  flex-shrink: 0;
  padding: 0.2rem 0.28rem calc(0.24rem + env(safe-area-inset-bottom));
  background: #fff;
}
.pre-read-agree {
  min-height: 0.76rem;
  border-radius: 0.4rem;
  background: #ff8537;
  color: #fff;
  font-size: 0.27rem;
  font-weight: 600;
}
.pre-read-agree:disabled {
  opacity: 0.6;
}
.pre-read-decline {
  padding: 0.08rem;
  background: transparent;
  color: #888;
  font-size: 0.22rem;
}
.product_detail {
  background-color: #f8f8f8;
  width: 100%;
  height: 100vh;
  padding-top: 1rem;
  .detail_header {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
    text-align: center;
    font-size: 0.36rem;
    font-weight: 500;
    color: #333333;
    height: 1rem;
    line-height: 1rem;
    background-color: #ffffff;
    img {
      position: absolute;
      width: 0.36rem;
      height: 0.36rem;
      top: 0.32rem;
      left: 0.32rem;
    }
  }
}
.detail_container {
  padding: 0.32rem;
  box-sizing: border-box;
  background-color: #f8f8f8;
  font-size: 0.24rem;
  .desc_span_box {
    width: 100%;
    margin-top: 0.32rem;

    .desc_span {
      font-weight: 400;
      font-size: 0.2rem;
      color: #999999;
      text-align: center;
    }
  }

  .check_declaration_card {
    width: 100%;
    background: #ffffff;
    border-radius: 0.2rem;
    margin-top: 0.2rem;
    padding: 0.32rem 0.32rem 0;
    box-sizing: border-box;

    .declartion_item {
      width: 100%;
      height: 1.04rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f2f3f4;

      .d_i_l {
        font-weight: 400;
        font-size: 0.25rem;
        color: #333333;
        line-height: 0.28rem;
      }

      .d_i_r {
        font-weight: 400;
        font-size: 0.25rem;
        color: #666666;
        line-height: 0.28rem;
      }
    }

    // 官网地址可能较长，允许值换行而不挤出详情卡片。
    .declartion_item--website {
      height: auto;
      min-height: 1.04rem;
      gap: 0.16rem;
      padding: 0.18rem 0;

      .d_i_l {
        flex: none;
      }

      .d_i_r {
        min-width: 0;
        text-align: right;
        overflow-wrap: anywhere;
      }
    }

    .title {
      font-weight: 500;
      font-size: 0.3rem;
      color: #333333;
      line-height: 1.5;
      margin-bottom: 0.1rem;
    }
  }

  .check_declaration_card .declartion_item:last-child {
    border: none;
  }

  .data_box {
    width: 100%;
    height: 4.36rem;
    text-align: center;
    background: linear-gradient(180deg, #6491ff 0%, #0b56fb 100%);
    box-shadow: inset 0px 0px 6px 0px rgba(255, 255, 255, 0.5);
    border-radius: 0.24rem;
    padding-top: 0.64rem;
    box-sizing: border-box;
    position: relative;

    .data_bottom_box {
      width: 100%;
      height: 1.52rem;
      background: #0345da;
      border: 1px solid rgba(255, 255, 255, 0.2);
      position: absolute;
      bottom: 0;
      left: 0;
      border-radius: 0 0 0.24rem 0.24rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.24rem;
      box-sizing: border-box;

      .line_first {
        width: 1px;
        height: 8px;
        background: #ffe2d3;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, 0);
      }

      .line_second {
        width: 1px;
        height: 8px;
        background: #ffe2d3;
        position: absolute;
        right: 2.34rem;
        top: 50%;
        transform: translate(-50%, 0);
      }

      .d_b_item_box {
        width: 100%;
        height: 100%;
        text-align: center;

        .num_span {
          font-family: DINAlternate, DINAlternate;
          font-weight: bold;
          font-size: 0.32rem;
          color: #ffffff;
          line-height: 0.32rem;
          margin-top: 0.38rem;
        }

        .num_span_desc {
          font-weight: 400;
          font-size: 0.24rem;
          color: #ffffff;
          line-height: 0.24rem;
          margin-top: 0.2rem;
        }

        // 较长的利率口径在左半区换行，避免覆盖右侧期限。
        .num_span_desc--rate {
          margin-top: 0.12rem;
          font-size: 0.2rem;
          line-height: 1.25;
        }
      }
    }

    .d_b_amount_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.56rem;
      position: relative;

      .edit_img {
        width: 0.24rem;
        height: 0.24rem;
        position: absolute;
        right: 61px;
        bottom: 4px;
      }

      .d_b_amount {
        width: 4rem;
        height: 0.8rem;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        input {
          width: 100%;
          font-weight: bold;
          font-size: 48px;
          color: #ffffff;
          line-height: 48px;
          position: relative;
          z-index: 2;
          text-align: center;
        }

        img {
          width: 4rem;
          height: 0.8rem;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }
      }
    }

    .d_b_desc {
      width: 100%;
      font-weight: 400;
      font-size: 0.42rem;
      color: #ffffff;
      line-height: 0.28rem;
      text-align: center;
    }
    .d_b_momey {
      width: 100%;
      font-weight: 400;
      font-size: 0.42rem;
      color: #ffffff;
      line-height: 0.28rem;
      text-align: center;
    }
  }
}

.stance {
  height: 2.6rem;
  background-color: #f8f8f8;
}

.bottom_box {
  width: 100%;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0.18rem 0.32rem 0;
  box-sizing: border-box;

  .b_b_btn {
    width: 100%;
    height: 1.08rem;
    background: #0a3b8c;
    box-shadow: 0px 2px 6px 0px rgba(46, 94, 253, 0.29);
    border-radius: 0.54rem;
    text-align: center;
    font-weight: 500;
    font-size: 0.36rem;
    color: #ffffff;
    line-height: 1.08rem;
    margin-bottom: 0.32rem;
  }

  .b_b_desc {
    width: 100%;
    position: relative;
    margin-bottom: 0.32rem;
    font-size: 0.24rem;
    .agreement-check {
      box-sizing: border-box;
      width: 0.32rem;
      height: 0.32rem;
      position: absolute;
      top: 0px;
      left: 4px;
      padding: 0;
      border: 0.02rem solid #8390a7;
      border-radius: 0.06rem;
      background: #fff;
    }

    .agreement-check--active {
      border-color: #164392;
      background: #164392;
    }

    .agreement-check--active::after {
      content: '';
      position: absolute;
      top: 0.02rem;
      left: 0.09rem;
      width: 0.08rem;
      height: 0.16rem;
      border: solid #fff;
      border-width: 0 0.025rem 0.025rem 0;
      transform: rotate(45deg);
    }

    .span_box {
      width: 6.22rem;
      margin-left: 0.56rem;
      .black_span {
        font-size: 0.24rem;
        color: #33394f;
        line-height: 1.5;
      }

      .orange_span {
        font-size: 0.24rem;
        color: #33394f;
        line-height: 1.5;
      }
    }
  }
}
</style>
